"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var generateUrlParams = function generateUrlParams(params) {
  return params.reduce(function (acc, param, i) {
    return i === 0 ? "".concat(param) : "".concat(acc, "&").concat(param);
  }, '');
};

var _default = generateUrlParams;
exports.default = _default;